import React, { useEffect, useState } from "react";
import { IInvoice } from "../../interfaces/IInvoice";
import { IInvoiceState } from "../../interfaces/IInvoiceState";
import { IInvoiceType } from "../../interfaces/IInvoiceType";
import { Alert, Box, Collapse, Grid, MenuItem, Tab, Tabs } from "@mui/material";
import { CustomeTextField } from "../core/CustomeTextField";
import { progressPaymentSchema } from "../../interfaces/IProgressPayment";
import { InvoiceProgressPaymentEdit } from "./InvoiceProgressPaymentEdit";
import { InvoiceLinkedEdit } from "./InvoiceLinkedEdit";
import { InvoicePosMaterialTable } from "./InvoicePosMaterialTable";
import { InvoicePosServiceTable } from "./InvoicePosServiceTable";
import { IRecipientOfPayment } from "../../interfaces/IRecipientOfPayment";
import { InvoiceCreditingTable } from "./InvoiceCreditingTable";


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}





interface IProps {
    editInv: IInvoice;
    setEditInv: Function;

    invocies: IInvoice[];
    bankAccounts: IRecipientOfPayment[];
    invStates: IInvoiceState[];
    invTypes: IInvoiceType[];

    isOpenNew: boolean;
    isOpenAssignMaterial: boolean;
    setIsOpenNew: Function;
    setIsOpenAssignMaterial: Function;
}


export const InvoiceEditor:React.FC<IProps> = ({
    editInv,
    setEditInv,
    invocies,
    bankAccounts,
    invStates,
    invTypes,

    isOpenNew,
    isOpenAssignMaterial,
    setIsOpenNew,
    setIsOpenAssignMaterial
}) => {
    const [progressPayment,setProgressPayment] = useState(
        editInv.ProgressPayment !== null 
        ? editInv.ProgressPayment
        : (editInv.InvoiceType === 20)
        ? progressPaymentSchema.parse({})
        : null
    );
    const [linkedInvoice,setLinkedInvoice] = useState(editInv.LinkedInvoices);
    //
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    function getAdjustedDate(): string {
        const today = new Date();
        const twoWeeksLater = new Date(today);
        twoWeeksLater.setDate(today.getDate() + 14);

        const dayOfWeek = twoWeeksLater.getDay(); // 0 = Sonntag, 6 = Samstag

        if (dayOfWeek === 6) {
            // Samstag → auf Montag (2 Tag)
            twoWeeksLater.setDate(twoWeeksLater.getDate() +2);
        } else if (dayOfWeek === 0) {
            // Sonntag → auf Montag (1 Tag)
            twoWeeksLater.setDate(twoWeeksLater.getDate() +1);
        }

        return twoWeeksLater.toISOString().split("T")[0];
    }



    useEffect(() => {
        setEditInv({
            ...editInv,
            ProgressPayment: progressPayment
        })
    },[progressPayment])
    useEffect(() => {
        setEditInv({
            ...editInv,
            LinkedInvoices: linkedInvoice
        })
    },[linkedInvoice])


    return(
        <>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Collapse in={editInv.invoice_number === "" && editInv.InvoiceState >= 20}>
                        <Alert severity="warning">
                            Wenn Sie den Entwurfsstatus verlassen, wird eine Rechnungsnummer generiert und Sie können diese Rechnung nicht mehr löschen! 
                        </Alert>
                    </Collapse>
                </Grid>

                <Grid item xs={4}>
                    <CustomeTextField
                        attr="invoice_number"
                        label="RG-Nummer"
                        object={editInv}
                        setObject={setEditInv}
                        type="string"
                        disabled
                    />
                </Grid>
                <Grid item xs={8}>
                    <CustomeTextField
                        attr="title"
                        label="Titel"
                        object={editInv}
                        setObject={setEditInv}
                        type="string"
                        required
                    />
                </Grid>

                <Grid item xs={6}>
                    <CustomeTextField
                        attr="InvoiceType"
                        label="Rechnungsart"
                        object={editInv}
                        setObject={setEditInv}
                        type="select"
                        disabled
                    >
                        {invTypes.map(type=> 
                            <MenuItem
                                key={`select-re-type-${type.id}`}
                                value={type.id}
                            >
                                {type.invoiceType}
                            </MenuItem>
                        )}
                    </CustomeTextField>
                </Grid>
                <Grid item xs={6}>
                    <CustomeTextField
                        attr="InvoiceState"
                        label="Rechnungsstatus"
                        object={editInv}
                        setObject={(updatedInv:IInvoice) => setEditInv({
                            ...updatedInv,
                            invoice_send_at: (updatedInv.InvoiceState === 20 && updatedInv.invoice_send_at === null) 
                                ? new Date().toISOString().split("T")[0] 
                                : updatedInv.invoice_send_at,
                            paid_to: (updatedInv.InvoiceState === 20 && updatedInv.invoice_send_at === null) 
                                ? getAdjustedDate()
                                : updatedInv.paid_to,
                            paid_at: ([50,51].includes(updatedInv.InvoiceState) && updatedInv.paid_at === null) 
                                ? new Date().toISOString().split("T")[0] 
                                : updatedInv.paid_at,
                        } as IInvoice)}
                        type="select"
                    >
                        {invStates.map(state=> 
                            <MenuItem
                                key={`select-re-state-${state.id}`}
                                value={state.id}
                            >
                                {state.invoiceState}
                            </MenuItem>
                        )}
                    </CustomeTextField>
                </Grid>
            </Grid>


            <Grid container spacing={2} sx={{mt: 3}}>
                <Grid item xs={4}>
                    <CustomeTextField
                        attr="invoice_send_at"
                        label="RG-Ausgangsdatum"
                        object={editInv}
                        setObject={setEditInv}
                        type="date"
                        null
                    />
                </Grid>
                <Grid item xs={4}>
                    <CustomeTextField
                        attr="paid_to"
                        label="Zahlungsziel"
                        object={editInv}
                        setObject={setEditInv}
                        type="date"
                        null
                        required
                    />
                </Grid>
                <Grid item xs={4}>
                    <CustomeTextField
                        attr="paid_at"
                        label="RG-Zahlungseingang"
                        object={editInv}
                        setObject={setEditInv}
                        type="date"
                        null
                    />
                </Grid>

                <Grid item xs={6}>
                    <CustomeTextField
                        attr="RecipientOfPayment"
                        label="Konto"
                        object={editInv}
                        setObject={setEditInv}
                        type="select"
                    >
                        {bankAccounts.map(type=> 
                            <MenuItem
                                key={`bankaccount-${type.id}`}
                                value={type.id}
                            >
                                {type.recipient} // {type.iban} 
                            </MenuItem>
                        )}
                    </CustomeTextField>
                </Grid>
                {(editInv.InvoiceType !== 50) &&
                    <Grid item xs={6}>
                        <CustomeTextField
                            attr="cash_discount"
                            label="Skonto in Prozent"
                            object={editInv}
                            setObject={setEditInv}
                            type="number"
                            null
                        />
                    </Grid>
                }

            </Grid>

            {[20].includes(editInv.InvoiceType) && 
                <InvoiceProgressPaymentEdit
                    progressPayment={progressPayment}
                    setProgressPayment={setProgressPayment}
                />
            }
            {[30].includes(editInv.InvoiceType) && 
                <InvoiceLinkedEdit
                    invoice={editInv}
                    invoices={invocies}
                    linkedInvoices={linkedInvoice}
                    setLinkedInvoices={setLinkedInvoice}
                />
            }


            <Box sx={{mt:5}}/>

            { (editInv.InvoiceType === 10) ?
                <InvoicePosMaterialTable
                    invoice={editInv}
                    setInvoice={setEditInv}
                    isOpenAssignMaterial={isOpenAssignMaterial}
                    isOpenNew={isOpenNew}
                    setIsOpenAssignMaterial={setIsOpenAssignMaterial}
                    setIsOpenNew={setIsOpenNew}
                />
                : (editInv.InvoiceType === 30) ?

                <InvoicePosServiceTable
                    key="edit-invpost-1"
                    invoice={editInv}
                    setInvoice={setEditInv}
                    isOpenNew={isOpenNew}
                    setIsOpenNew={setIsOpenNew}
                    invoiceServicePositionType={10}
                />

                : (editInv.InvoiceType === 40) ?
                    <InvoicePosServiceTable
                        invoice={editInv}
                        setInvoice={setEditInv}
                        isOpenNew={isOpenNew}
                        setIsOpenNew={setIsOpenNew}
                        invoiceServicePositionType={10}
                    />
                : (editInv.InvoiceType === 50) ?
                    <InvoiceCreditingTable
                        invoice={editInv}
                        setInvoice={setEditInv}
                        isOpenNew={isOpenNew}
                        setIsOpenNew={setIsOpenNew}
                    />
                : <></>
            }
        </>
    )
}